module.exports = __webpack_public_path__ + "static/media/Avatars_Male-32.b2c8190e.png";